import React from 'react'
import {ElementsConsumer} from '@stripe/react-stripe-js'

import EventAttendees from '../EventAttendees'

const InjectedEventAttendees = () => {
    return (
        <ElementsConsumer>
            {({elements, stripe}) => (
                <EventAttendees elements={elements} stripe={stripe} />
            )}
        </ElementsConsumer>
    )
}

export default InjectedEventAttendees